const find = {
  vehicleCategory: {
    method: 'get',
    url: '/utils/find/vehicle-category'
  }
}

export default {
  find,
  journeyAlerts: {
    method: 'get',
    url: '/utils/journey-alerts'
  }
}
